module.exports = "mutation UpdateCustomersTransports($data:[UpdateCustomersTransportsInput]!){updateCustomersTransports(data:$data){success}}"